(function() {
  'use strict';

  if (typeof window.EcSliderCard !== 'undefined') {
    return;
  }

  class EcSliderCard {
    constructor(sectionId, config) {
      this.sectionId = sectionId;
      this.config = config || {};
      
      const sectionSelector = `.${sectionId}`;
      this.sliderComponent = document.querySelector(sectionSelector + ' slider-component');
      
      if (!this.sliderComponent) return;

      this.slider = this.sliderComponent.querySelector('.ec-slider-card-track');

      if (!this.slider) return;

      this.dotsContainer = this.sliderComponent.querySelector('[data-slider-controls="bottom-right"]');
      this.prevButton = this.sliderComponent.querySelector('button[name="previous"]');
      this.nextButton = this.sliderComponent.querySelector('button[name="next"]');

      this.slides = this.slider.querySelectorAll('.ec-slider-card-slide');
      this.originalCount = this.slides.length;
      
      if (this.originalCount < 2) return;

      this.autoRotateTimer = null;
      this.isInitialized = false;

      this.init();
    }

    init() {
      setTimeout(() => {
        this.cloneSlides();
        this.setInitialScroll();
        this.setupEventListeners();
        this.setupDots();
        
        if (this.config.autoRotateEnabled) {
          setTimeout(() => this.startAutoRotate(), 2000);
        }
        
        this.isInitialized = true;
      }, 300);
    }

    cloneSlides() {
      for (let i = this.originalCount - 1; i >= 0; i--) {
        const clone = this.slides[i].cloneNode(true);
        clone.setAttribute('data-ec-clone', '1');
        clone.removeAttribute('id');
        this.slider.insertBefore(clone, this.slider.firstChild);
      }
      
      for (let i = 0; i < this.originalCount; i++) {
        const clone = this.slides[i].cloneNode(true);
        clone.setAttribute('data-ec-clone', '1');
        clone.removeAttribute('id');
        this.slider.appendChild(clone);
      }
      
      this.slides = this.slider.querySelectorAll('.ec-slider-card-slide');
    }

    getStep() {
  const w = this.getSlideWidth();
  const g = this.getGap();
  const step = Math.round(w + g);
  return step > 0 ? step : 0;
}





    getGap() {
      const track = this.slider; // garantindo que slider = track
      const g = parseFloat(getComputedStyle(track).gap);
      return isNaN(g) ? (window.innerWidth <= 749 ? 20 : 22) : g;
    }

    getSlideWidth() {
      const first = this.slider.querySelector('.ec-slider-card-slide');
      return first ? first.offsetWidth : 0;
    }

    getLapWidth() {
  const step = this.getStep();
  return step > 0 ? this.originalCount * step : 0;
}

    setInitialScroll() {
      const lw = this.getLapWidth();
      if (lw > 0) {
        this.slider.scrollLeft = lw;
      }
    }

    onScrollWrap() {
      const lw = this.getLapWidth();
      if (lw <= 0) return;
      
      if (this.slider.scrollLeft >= 2 * lw - 2) {
        this.slider.scrollLeft = this.slider.scrollLeft - lw;
      } else if (this.slider.scrollLeft <= 2) {
        this.slider.scrollLeft = this.slider.scrollLeft + lw;
      }
    }

    goNext() {
      const step = this.getStep();
      if (!step) return;
      this.slider.scrollBy({ left: step, behavior: 'smooth' });

    }

    goPrev() {
      const step = this.getStep();
      if (!step) return;
      this.slider.scrollBy({ left: -step, behavior: 'smooth' });
    }

    setupEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goPrev();
        }, true);
      }
      
      if (this.nextButton) {
        this.nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goNext();
        }, true);
      }

      this.slider.addEventListener('scroll', () => this.onScrollWrap(), { passive: true });

      if (this.config.autoRotateEnabled) {
        this.sliderComponent.addEventListener('mouseenter', () => this.stopAutoRotate());
        this.sliderComponent.addEventListener('mouseleave', () => this.startAutoRotate());
        this.sliderComponent.addEventListener('touchstart', () => this.stopAutoRotate(), { passive: true });
        this.sliderComponent.addEventListener('touchend', () => {
          setTimeout(() => this.startAutoRotate(), 3000);
        }, { passive: true });
      }

      window.addEventListener('resize', () => {
        const lw = this.getLapWidth();
        if (lw > 0) this.slider.scrollLeft = lw;
        this.updateDotsActiveState();
      });

    }

    getTrackPadding() {
      return window.innerWidth <= 749 ? (parseFloat(getComputedStyle(this.slider).paddingLeft) || 0) : 0;
    }

    setupDots() {
  if (!this.dotsContainer) return;

  const dots = this.dotsContainer.querySelectorAll('.slider-counter__link');
  if (dots.length === 0) return;

  dots.forEach((dot) => {
    const slideIndex = parseInt(dot.getAttribute('data-slide-index') || '0');
    dot.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const lw = this.getLapWidth();
      const step = this.getStep();
      if (!lw || !step) return;

      const trackPadding = this.getTrackPadding();
      const targetPosition = lw + trackPadding + step * slideIndex;

      this.slider.scrollTo({ left: targetPosition, behavior: 'smooth' });
    }, true);
  });

  this.slider.addEventListener('scroll', () => this.updateDotsActiveState());
  setTimeout(() => this.updateDotsActiveState(), 400);
}


    updateDotsActiveState() {
      if (!this.dotsContainer) return;

      const dots = this.dotsContainer.querySelectorAll('.slider-counter__link');
      if (dots.length === 0) return;

      const step = this.getStep();
      if (step <= 0) return;

      const trackPadding = this.getTrackPadding();
      const lw = this.getLapWidth();

      let idx = Math.round((this.slider.scrollLeft - trackPadding - lw) / step);
      idx = ((idx % this.originalCount) + this.originalCount) % this.originalCount;
      const currentIndex = Math.max(0, Math.min(idx, this.originalCount - 1));

      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('slider-counter__link--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('slider-counter__link--active');
          dot.removeAttribute('aria-current');
        }
      });
    }


    startAutoRotate() {
      if (!this.config.autoRotateEnabled || !this.isInitialized) return;
      
      this.stopAutoRotate();
      this.autoRotateTimer = setInterval(() => this.goNext(), this.config.autoRotateMs);
    }

    stopAutoRotate() {
      if (this.autoRotateTimer) {
        clearInterval(this.autoRotateTimer);
        this.autoRotateTimer = null;
      }
    }
  }

  window.EcSliderCard = EcSliderCard;

  function initSliderCards() {
    const sliderCards = document.querySelectorAll('[data-ec-slider-card]');
    
    sliderCards.forEach(section => {
      const sectionId = section.dataset.ecSliderCard;
      const autoRotateEnabled = section.dataset.ecAutoRotate === 'true';
      const autoRotateMs = parseInt(section.dataset.ecAutoRotateMs) || 5000;
      
      if (!section.hasAttribute('data-ec-card-initialized')) {
        section.setAttribute('data-ec-card-initialized', 'true');
        new EcSliderCard(sectionId, {
          autoRotateEnabled: autoRotateEnabled,
          autoRotateMs: autoRotateMs
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initSliderCards, 500);
    });
  } else {
    setTimeout(initSliderCards, 500);
  }
})();
